import React from "react";
// import RoomBookingTable from "./Components/RoomBookingTable";
// import { useDispatch} from "react-redux"
import { useLocation, useNavigate } from "react-router-dom";
import BookingLogsTable from "./Components/BookingLogsTable";

const BookingLogsList = () => {
  // const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const { reservation_id } = location.state || {};

  const handleNavigate = () => {
    navigate("/reservation/add-room-booking");
  };

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Booking Logs List</h3>
              {/* <div className="col-auto d-flex w-sm-100">
                <button
                  type="button"
                  className="btn btn-dark"
                  // data-bs-toggle="offcanvas"
                  // data-bs-target="#room-reservation"
                  // aria-controls="room-reservation"
                  onClick={() => handleNavigate()}
                >
                  Room Book
                </button>
              </div> */}
              <button
                type="button"
                className="btn btn-secondary"
                style={{ maxHeight: "40px" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Back
              </button>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <BookingLogsTable
                  reservation_id={reservation_id}
                  // data ={roomReservation.data}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BookingLogsList;
